import React, { useCallback, memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useAccordion } from 'site-modules/shared/components/inventory/accordion/use-accordion';

import './accordion-item.scss';

export const AccordionItem = memo(
  ({
    children,
    id,
    className = '',
    summary,
    trackingValue = '',
    trackingId = 'extra_links_show_all',
    noIcon = false,
  }) => {
    const { onToggleItem, openedItems } = useAccordion();

    const isItemOpened = openedItems.includes(id);

    const handleSummaryClick = useCallback(
      event => {
        onToggleItem(id, !isItemOpened);
        event.preventDefault();
      },
      [id, isItemOpened, onToggleItem]
    );

    return (
      <details open={isItemOpened} className={classnames('accordion-item', className)}>
        <summary
          className={classnames('d-flex align-items-center', className)}
          onClick={handleSummaryClick}
          data-tracking-id={trackingId}
          data-tracking-value={trackingValue}
          {...(trackingValue ? {} : { 'data-tracking-ignore-value': true })}
        >
          <div className="accordion-item-summary">{summary}</div>
          {!noIcon && (
            <i
              className={classnames('medium text-primary-darker', {
                'icon-arrow-down4': !isItemOpened,
                'icon-arrow-up4': isItemOpened,
              })}
              aria-hidden
            />
          )}
        </summary>
        {children}
      </details>
    );
  }
);

AccordionItem.propTypes = {
  children: PropTypes.node.isRequired,
  summary: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  trackingValue: PropTypes.string,
  trackingId: PropTypes.string,
  noIcon: PropTypes.bool,
};

AccordionItem.displayName = 'AccordionItem';
